import styled from 'styled-components'
import { themeGet } from 'styled-system'

export const Container = styled.div`
  margin-bottom: 2rem;
`

export const Label = styled.label`
  color: ${themeGet('colors.darkGray')};
  font-family: ${themeGet('textFontFamilySemibold')};
  font-size: 1rem;
  line-height: 1;
  margin-bottom: 0.375rem;
`

export const ArchetypeContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 1rem;
`

export const CheckboxLabel = styled.label`
  font-size: 1rem;
  font-family: ${themeGet('textFontFamily')};
  margin-left: 0.5rem;
  margin-bottom: 0;
  line-height: 1;
`

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.8125rem;
  :last-child {
    margin-bottom: 0;
  }
`



// WEBPACK FOOTER //
// ./src/components/AccountDetailsCheckboxInput/AccountDetailsCheckboxInput.styles.js